jQuery( document ).ready(function() {
  jQuery('.custom_swatches_color').click(function(){
  var getClickValue = $(this).attr('data-tooltip');
  $(".Color_"+getClickValue).click();
  jQuery(".swatch-element").each(function() {
    jQuery(this).removeClass('activeSwatch')
  });
  jQuery(this).parent().addClass("activeSwatch");
});

jQuery(window).on('load', function() {
  setTimeout(function() {
    jQuery('.colSwatchItem').click(function(){
      jQuery('.colSwatchItem').each(function() {
        jQuery(this).removeClass('activeSwatch')
      });
      jQuery(this).addClass("activeSwatch");
    });
  }, 3000);
});



jQuery(".swatchCount").each(function() {
    jQuery(this).click(function(){
      if (jQuery(this).parent().hasClass("showMoreSwatch")) {
        jQuery(this).parent().removeClass("showMoreSwatch");
        jQuery(this).find("span").text('+');
      }else{
        jQuery(this).parent().addClass("showMoreSwatch");
        jQuery('.showMoreSwatch .moreSwatchSign').text('-');
      }
    });
  });
 setTimeout(function() {
  jQuery('.swatch-element').click(function(){
    var img_src = jQuery(this).attr('data-image'); ////cdn.shopify.com/s/files/1/1806/3989/products/snakeembossedleatherpurse_grande.jpg?v=1643205056
    var card = jQuery(this).attr('data-item'); //col_item_2
    if(img_src != ""){
      jQuery('.'+card+' .card__media .primaryImage').attr('src',img_src);
      jQuery('.'+card+' .card__media .primaryImage').attr('srcset',img_src);
    }
  });
  }, 3000);
});


function addedNumbers(identifier){
  var data_id = $(identifier).data('id');	
  var data_product_id = $(identifier).data('p-id');
  jQuery("."+data_id).toggleClass("showMoreSwatch");
  var sign_text = document.getElementById("sign_"+data_product_id).textContent;
  
  if(sign_text == "+"){
   document.getElementById("sign_"+data_product_id).textContent = "-";
   document.getElementById("sign_mobile_"+data_product_id).textContent = "-";
  }else{
   document.getElementById("sign_"+data_product_id).textContent = "+";
    document.getElementById("sign_mobile_"+data_product_id).textContent = "+";
  }
}


function changeSwatchImage(identifier){
  var img_src = $(identifier).data('image');	
  var card = $(identifier).data('item');
  var pro_id = $(identifier).data('pro-id');

  var i = document.getElementById("primaryImage_"+pro_id);
  if(img_src != ""){
    i.setAttribute('src', img_src);
    i.setAttribute('srcset', img_src);
  }
}


function recomendedNumbers(){
  jQuery(".swatchCount").click(function(){
    if (jQuery(this).parent().hasClass("showMoreSwatch")){
      jQuery(this).parent().removeClass("showMoreSwatch");
      jQuery(this).find("span").text('+');
    }else{
      jQuery(this).parent().addClass("showMoreSwatch");
      jQuery('.showMoreSwatch .moreSwatchSign').text('-');
    }
  });
}